import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, mouseInteractivity_ToolTip } from '@nu-art/thunderstorm-frontend/index';
import { ConsiderationGroupEnum, ProtocolListAssignment } from '@app/advisor-shared';
import './Popup_Protocol.scss';
import { ICONS } from '@app/styles';
import { filterKeys } from '@nu-art/ts-common';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { ModuleFE_ProvideInfo } from '../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_ProvideInfo } from '@app/advisor-v5-shared';
export class Popup_Protocol extends ComponentSync {
    static show = (e, protocolData, dir = 'bottom') => {
        if (ModuleFE_EMInterface.isReadonly())
            return;
        const rect = e.currentTarget?.getBoundingClientRect();
        if (!rect)
            return;
        const model = {
            content: _jsx(Popup_Protocol, { protocolData: protocolData }),
            id: 'pop-up__protocol',
            originPos: {
                x: rect.left,
                y: dir === 'bottom' ? rect.bottom : rect.top,
            },
            modalPos: {
                x: 1,
                y: dir === 'bottom' ? 1 : -1,
            },
            offset: {
                y: dir === 'bottom' ? 4 : -4,
            },
        };
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
        ModuleFE_MouseInteractivity.showContent(model);
    };
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        return state;
    }
    render() {
        return _jsxs(_Fragment, { children: [this.render_SwitchConsideration(), this.render_OpenMap(), this.render_ShowReasoning()] });
    }
    openMap = (showDetails = false) => {
        const data = this.state.protocolData;
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        ModuleFE_ProvideInfo.protocol.open(data.protocol._id, false, showDetails);
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            ModuleFE_AdvisorMini.openPanel(PanelKey_ProvideInfo);
    };
    render_SwitchConsideration = () => {
        const protocolData = this.state.protocolData;
        // Ended protocols have no consideration tier to change -> hide the toggle.
        if (protocolData.getListAssignment() === ProtocolListAssignment.ENDED)
            return null;
        const moveToHigh = protocolData.getConsideration() === ConsiderationGroupEnum.LOW_CONSIDERATION;
        const label = `Move to ${moveToHigh ? 'High' : 'Low'} Consideration`;
        return _jsxs(Button, { variant: 'text', onClick: async () => {
                await ModuleFE_EMInterface.vv1.protocols.switchProtocolConsiderationGroup({ runtimeProtocolId: protocolData.protocol._id }).executeSync();
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                //Report analytics event
                ModuleFE_AdvisorAnalytics.trigger.navigation.navigation_considerationSwitch({
                    protocolId: protocolData.protocol._id,
                    protocolLabel: protocolData.getLabel(),
                    considerationLevel: moveToHigh ? ConsiderationGroupEnum.HIGH_CONSIDERATION : ConsiderationGroupEnum.LOW_CONSIDERATION,
                });
            }, children: [_jsx(ICONS.advisor_v5_consideration.component, { style: filterKeys({ transform: moveToHigh ? 'rotate(-90deg)' : undefined }) }), label] });
    };
    render_OpenMap = () => {
        return _jsxs(Button, { variant: 'text', onClick: () => this.openMap(), children: [_jsx(ICONS.advisor_v5_navMode.component, { className: 'open-map' }), "Open Pathway Map"] });
    };
    render_ShowReasoning = () => {
        return _jsxs(Button, { variant: 'text', onClick: () => this.openMap(true), children: [_jsx(ICONS.advisor_v5_explain.component, {}), "Show Reasoning"] });
    };
}
//# sourceMappingURL=Popup_Protocol.js.map